import axios from 'axios';
import React from 'react';
import { useDispatch } from 'react-redux';
import { baseApi } from '../api/api';
import { refreshLogin } from '../Redux/Actions/userAction';
import { AUTH_SESSION_RESOLVED } from '../Redux/constant';

/**
 * 서버는 refresh마다 DB의 refreshToken을 교체한다(User.findOne({ refreshToken })).
 * React Strict Mode 등으로 /user/refresh가 동시에 두 번 나가면 첫 응답 후 두 번째는 401이 되고
 * AUTH_SESSION_RESOLVED가 로그인 상태를 덮어쓸 수 있으므로, 진행 중인 요청은 하나만 공유한다.
 */
let refreshSessionPromise = null;

function refreshSessionOnce(dispatch) {
  if (!refreshSessionPromise) {
    refreshSessionPromise = (async () => {
      try {
        const { status, data } = await axios.get(`${baseApi}/user/refresh`, {
          withCredentials: true,
        });
        await dispatch(refreshLogin(status, data));
      } catch (err) {
        console.log(err);
        dispatch({ type: AUTH_SESSION_RESOLVED, payload: { auth: false, user: {} } });
      } finally {
        refreshSessionPromise = null;
      }
    })();
  }
  return refreshSessionPromise;
}

export const useRefreshLogin = () => {
  const [loading, setLoading] = React.useState(true);
  const dispatch = useDispatch();
  React.useEffect(() => {
    let active = true;
    refreshSessionOnce(dispatch).finally(() => {
      if (active) setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [dispatch]);
  return { loading };
};
